import { ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';

import { ClientStyle } from 'components/ClientStyle/ClientStyle';
import { I18nHelper } from 'components/TestHelper/components/I18nHelper';

import { useAppTheme } from 'hooks/useAppTheme';
import { PointsHandlerProvider } from 'hooks/usePointsHandler';
import { SettingsProvider } from 'hooks/useSettings';
import { UserInfoProvider } from 'hooks/useUserInfo';

import { queryClient } from './queryClient';

export interface AppContextProps {
  children?: React.ReactNode;
  i18n?: boolean;
}

function AppTheme({ children = null }: { children?: React.ReactNode }) {
  const theme = useAppTheme();

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export function AppContext({ children = null, i18n = false }: AppContextProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nHelper enabled={i18n}>
        <ClientStyle>
          <AppTheme>
            <SettingsProvider>
              <UserInfoProvider>
                <PointsHandlerProvider>{children}</PointsHandlerProvider>
              </UserInfoProvider>
            </SettingsProvider>
          </AppTheme>
        </ClientStyle>
      </I18nHelper>
    </QueryClientProvider>
  );
}
